/* Composables */
import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'

/* Components */
import Login from '@/components/Login.vue'
import Logout from '@/components/Logout.vue'
import Cadastro from '@/components/Cadastro.vue'
import Termos from '@/components/Termos.vue'
import Recuperar from '@/components/Recuperar.vue'
import NovaSenha from '@/components/NovaSenha/NovaSenha.vue'
import TwoFactorsAuth from '../components/TwoFactorsAuth.vue'
import TwoFactorsAuthV2 from '../components/TwoFactorsAuthV2.vue'
import FaceBiometry from '@/components/FaceBiometry.vue'
import FaceFortBiometry from '@/components/FaceFortBiometry.vue'
import CreateGuardian from '@/components/CreateGuardian.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Login,
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout,
    },
    {
      path: '/Recuperar/',
      name: 'Recuperar',
      component: Recuperar,
    },
    {
      path: '/NovaSenha/',
      name: 'NovaSenha',
      component: NovaSenha,
    },
    {
      path: '/Cadastro',
      name: 'Cadastro',
      component: Cadastro,
    },
    {
      path: '/Auth',
      name: 'TwoFactorsAuth',
      component: TwoFactorsAuth,
    },
    {
      path: '/AuthV2',
      name: 'TwoFactorsAuthV2',
      component: TwoFactorsAuthV2,
    },
    {
      path: '/FaceBiometry',
      name: 'FaceBiometry',
      component: FaceBiometry,
    },
    {
      path: '/FaceFortBiometry',
      name: 'FaceFortBiometry',
      component: FaceFortBiometry,
    },
    {
      path: '/termos',
      name: 'Termos',
      component: Termos,
    },
    {
      path: '/Authorize',
      name: 'Authorize',
      component: Login,
      props: { authorize: true },
    },
    {
      path: '/create-guardian/',
      name: 'CreateGuardian',
      component: CreateGuardian,
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

router.beforeEach((_routeTo, _routeFrom, next) => {
  NProgress.start()
  next()
})

router.afterEach(() => {
  NProgress.done()
})

export default router
